import { useState } from 'react';

export function useQuestionPreviewNavigation(totalQuestions: number) {
  const [currentQuestionOrder, setCurrentQuestionOrder] = useState(1);

  const goToNextQuestion = () => {
    setCurrentQuestionOrder((prev) => Math.min(prev + 1, totalQuestions));
  };

  const goToPreviousQuestion = () => {
    setCurrentQuestionOrder((prev) => Math.max(prev - 1, 1));
  };

  const resetCurrentQuestionOrder = () => {
    setCurrentQuestionOrder(1);
  };

  return {
    currentQuestionOrder,
    goToNextQuestion,
    goToPreviousQuestion,
    resetCurrentQuestionOrder,
  };
}
